import Progress from 'redux-progress';
import { Account } from 'modules/accounts/model';
import { HamsCart } from 'modules/cart/duck/model';

export type AddonConfigMode = 'choose' | 'search';

export const CHOOSE: AddonConfigMode = 'choose';
export const SEARCH: AddonConfigMode = 'search';

export type ChooseModeState = {
  accountId: number | null;
  cartItemId: number | null;
};

export type SearchModeState = {
  sen: string | null;
  email: string | null;
  result: Progress<Account | null>;
};

export type AddonState = {
  mode: AddonConfigMode;

  choose: ChooseModeState;
  search: SearchModeState;

  terms: { [parentKey: string]: number | null };

  submitProgress: Progress<HamsCart>;
};
